import { useEffect, useState } from 'react';
import Input from 'components/common/inputs/Input';
import SectionCard from './SectionCard';
import useValidationConsolidator from 'hooks/useValidationConsolidator';
import { inputState } from 'state';
import { useRecoilState } from 'recoil';
import { findInDictionary } from 'helpers/parse';
import user from 'api/user';

function BankSection(props) {
  const {
    config,
    data = {},
    isValid = () => {},
    inputs: dictionary,
    name,
  } = props;

  const fields = config?.enrollment?.form?.sections?.[name]?.fields || [];
  const { title, sectionList } = data;

  const arrayOfInputValidationFunctions = useValidationConsolidator(
    fields, // empty array makes the section optional
    isValid,
  );

  if (!config?.enrollment?.form?.sections?.[name]?.fields) return null;
  return (
    <SectionCard title={title} list={sectionList}>
      {fields.map((field, index) => {
        const inputConfig = config.inputs[field];
        if (field === 'jp-bank-info')
          return (
            <JPBankIdBranchIdComponent
              key={field}
              config={config}
              dictionary={dictionary}
              isValid={arrayOfInputValidationFunctions[index]}
            />
          );
        return (
          <Input
            {...inputConfig}
            id={field}
            key={`${name}-${field}`}
            dictionary={dictionary}
            isValid={arrayOfInputValidationFunctions[index]}
            data={data}
            country={config.market}
          />
        );
      })}
    </SectionCard>
  );
}
export default BankSection;

function JPBankIdBranchIdComponent(props) {
  const { config, dictionary, isValid } = props;
  const [inputs, setInputs] = useRecoilState(inputState);
  const { ID_BANK, ID_BRANCH, NAME_BANK, NAME_BRANCH, NAME_ON_BANK } = inputs;

  useEffect(() => {
    if (!ID_BANK || /^0+$/.test(ID_BANK)) return;
    const formattedBankId = ID_BANK.toString().padStart(4, '0');
    user.getJapanBankInfo(formattedBankId).then((name) => {
      setInputs((prev) => ({ ...prev, NAME_BANK: name?.trim() }));
    });
  }, [ID_BANK]);

  useEffect(() => {
    if (
      !ID_BANK ||
      /^0+$/.test(ID_BANK) ||
      !ID_BRANCH ||
      /^0+$/.test(ID_BRANCH)
    )
      return;
    const formattedBankId = ID_BANK.toString().padStart(4, '0');
    const formattedBranchId = ID_BRANCH.toString().padStart(3, '0');
    user.getJapanBranchInfo(formattedBankId, formattedBranchId).then((name) => {
      setInputs((prev) => ({ ...prev, NAME_BRANCH: name?.trim() }));
    });
  }, [ID_BANK, ID_BRANCH]);

  useEffect(() => {
    const isValidForm =
      NAME_BANK?.trim() &&
      NAME_BRANCH?.trim() &&
      NAME_ON_BANK?.trim() &&
      ID_BANK?.trim() &&
      ID_BRANCH?.trim();

    isValid(!!isValidForm);
  }, [NAME_BANK, NAME_BRANCH, NAME_ON_BANK, ID_BANK, ID_BRANCH]);

  function setBankInfo(id, value) {
    setInputs({ ...inputs, [id]: value });
  }

  function handleBlur(id) {
    if (id === 'ID_BANK' && inputs.ID_BANK && !isNaN(inputs.ID_BANK)) {
      const formattedBankId = inputs.ID_BANK.toString().padStart(4, '0');
      setInputs({
        ...inputs,
        ID_BANK: formattedBankId,
        ID_BRANCH: '',
        NAME_BRANCH: '',
      });
    } else if (
      id === 'ID_BRANCH' &&
      inputs.ID_BRANCH &&
      !isNaN(inputs.ID_BRANCH)
    ) {
      const formattedBranchId = inputs.ID_BRANCH.toString().padStart(3, '0');
      setInputs({ ...inputs, ID_BRANCH: formattedBranchId });
    }
  }

  const inputProps = {
    country: config.market,
    dictionary,
  };
  // const errorMessage = findInDictionary(dictionary, 'ID_BRANCH', false).error;
  return (
    <>
      <Input
        {...inputProps}
        id="ID_BANK"
        value={ID_BANK || ''}
        onChange={setBankInfo}
        onBlur={() => handleBlur('ID_BANK')}
      />
      <Input
        {...inputProps}
        id="NAME_BANK"
        value={NAME_BANK || ''}
        onChange={setBankInfo}
      />
      <Input
        {...inputProps}
        id="ID_BRANCH"
        value={ID_BRANCH || ''}
        onChange={setBankInfo}
        onBlur={() => handleBlur('ID_BRANCH')}
      />
      <Input
        {...inputProps}
        id="NAME_BRANCH"
        value={NAME_BRANCH || ''}
        onChange={setBankInfo}
      />
      <Input
        {...inputProps}
        id="NAME_ON_BANK"
        value={NAME_ON_BANK || ''}
        onChange={setBankInfo}
      />
      {/* <Response data={bankInfo} errorMessage={errorMessage} /> */}
    </>
  );
}
